import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import Select from "react-select";
import SellIcon from "@mui/icons-material/Sell";
import CreatableSelect from "react-select/creatable";
import { useGlobalContext } from "../../../Context/GlobalContext";
import { use } from "react";
import Search from '@mui/icons-material/Search';
import SearchStaff from "../SearchStaff";
import { set } from "react-hook-form";
import Cookies from "js-cookie";


const ProjectEditModal = ({ open, setOpen, editProject, fetchProjects, fetchStatusProject, fetchPriorityProject
}) => {
  const {
    baseUrl,
    clientData,
    selectedStaff,
    openToast,
    searchClient,
    setSearchedClient,
    searchedClient,
  } = useGlobalContext();
  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(false);
  const [isEdit, setIsEdit] = useState(false);
  const [members, setMembers] = useState([]);
  const [tags, setTags] = useState([
    { value: "thumbnail", label: "thumbnail" },
    { value: "youtube", label: "youtube" },
    { value: "youtube thumbnail", label: "youtube thumbnail" },
    { value: "carousel", label: "carousel" },
    { value: "RE-DESIGN", label: "REDESIGN" },
    { value: "Ads", label: "Ads" },
    { value: "drdcrcrc", label: "drdcrcrc" },
  ]);
  const [projectName, setProjectName] = useState(
    editProject?.project_name || ""
  );
  const [names, setNames] = useState([]);
  const [calculate, setCalculate] = useState(true);
  const [billingType, setBillingType] = useState("");
  const [status, setStatus] = useState("");
  const [priority, setPriority] = useState("");
  const [rate, setRate] = useState(editProject?.total_rate || "");
  const [estimateHours, setEstimateHours] = useState(
    editProject?.estimated_hours || ""
  );
  const [startDate, setStartDate] = useState(editProject?.start_date || "");
  const [deadLine, setDeadLine] = useState(editProject?.deadline || "");
  const [description, setDescription] = useState(
    editProject?.description || ""
  );
  const [inputValue, setInputValue] = useState("");
  const [selectedTag, setSelectedTag] = useState([]);
  const [emailChecked, setEmailChecked] = useState(false);
  const [fetchProjectStatus, setFetchProjectStatus] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedClient, setSelectClient] = useState(null);
  const [fetchProjectPriority, setFetchProjectPriority] = useState([]);

  console.log(editProject);

  async function fetchProjectStatusDetails() {
    try {
      const result = await fetch(baseUrl + "project-status", {
        headers: {
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`
        }
      }
      );
      const data = await result.json();
      setFetchProjectStatus(data.data);
    } catch (error) {
      openToast(error.message, "error");
    }
  }

  async function fetchProjectPriorityDetails() {
    try {
      const result = await fetch(baseUrl + "project-priority", {
        headers: {
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`
        }
      }
      );
      const data = await result.json();
      setFetchProjectPriority(data.data);
    } catch (error) {
      openToast(error.message, "error");
    }
  }

  useEffect(() => {
    if (editProject) {
      setPriority(editProject?.priority);
      setNames(editProject?.staffId);
      setSelectClient(editProject?.customerDetails);
      setBillingType(editProject?.billing_type);
      setStatus(editProject?.status);
    }
  }, [editProject]);

  console.log(editProject);
  useEffect(() => {
    fetchProjectStatusDetails();
    fetchProjectPriorityDetails();
  }, []);
  const handleChange = (selectedOptions) => {
    setSelectedTag(selectedOptions);
  };

  useEffect(() => {
    if (editProject?.tags) {
      setSelectedTag(
        editProject?.tags.map((tag) => ({ value: tag, label: tag }))
      );
    }
  }, [editProject]);

  const [newCustomer, setNewCustomer] = useState(null);


  useEffect(() => {
    setProjectName(editProject?.project_name || "");
    setRate(editProject?.total_rate || "");
    setMembers(editProject?.staffId?.map((item) => item?.id) || []);
    setEstimateHours(editProject?.estimated_hours || "");
    setStartDate(editProject?.start_date || "");
    setDeadLine(editProject?.deadline || "");
    setDescription(editProject?.description || "");
  }, [editProject]);

  console.log(members);

  async function updateProject(e) {
    e.preventDefault();

    // Comprehensive validation
    if (!projectName.trim()) {
      openToast("Project name is required", "error");
      return;
    }

    if (!newCustomer && !selectedClient) {
      openToast("Please select a customer", "error");
      return;
    }

    if (!status) {
      openToast("Please select a project status", "error");
      return;
    }

    try {
      setIsLoading(true);
      const response = await fetch(baseUrl + `project/${editProject?.id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`
        },
        body: JSON.stringify({
          priority: priority.toString(),
          project_name: projectName.trim(),
          staffId: members,
          customerId: newCustomer?.clientDetails?.id || selectedClient?.id,
          billing_type: billingType,
          status: status,
          total_rate: rate.toString(),
          start_date: startDate,
          deadline: deadLine,
          description: description.trim(),
          tags: selectedTag.map((tag) => tag.value),
          estimated_hours: estimateHours.toString(),
          send_mail: emailChecked,
        }),
      });

      const responseData = await response.json();

      if (response.ok) {
        // Reset all form states
        resetFormStates();

        // Fetch updated data
        fetchProjects();
        fetchStatusProject();
        fetchPriorityProject();

        openToast("Project Updated Successfully", "success");
        onCloseModal();
      } else {
        // Handle API error responses
        openToast(responseData.message || "Failed to update project", "error");
      }
    } catch (error) {
      console.error("Project update error:", error);
      openToast("Network error. Please try again.", "error");
    } finally {
      setIsLoading(false);
    }
  }

  // Helper function to reset form states
  function resetFormStates() {
    setEstimateHours("");
    setRate("");
    setProjectName("");
    setStartDate("");
    setDeadLine("");
    setDescription("");
    setMembers([]);
    setBillingType("");
    setStatus("");
    setPriority("");
    setNewCustomer(null);
    setSelectClient(null);
    setSelectedTag([]);
    setEmailChecked(false);
  }

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);
    if (value === "") {
      setSearchedClient(null);
    } else {
      searchClient(value);
    }
  };

  return (
    <div>
      <Modal
        open={open}
        onClose={onCloseModal}
        center
        classNames={{
          modal:
            "max-h-[90vh] overflow-y-auto p-4 w-[90%] max-w-[600px] custom-scrollbar",
        }}
      >
        <h1 className="mt-[6px] mb-[20px] font-medium text-[18px]">
          Edit Project
        </h1>
        {/* <!-- Form starts --> */}
        <form onSubmit={updateProject}>
          <div className="space-y-5 w-[100%]">
            <div className="space-y-2">
              <label className="font-medium text-gray-700 text-sm">
                * Project Name
              </label>
              <input
                className="border-[#DBDCDE] pl-2 border rounded-md w-[100%] h-[35px] focus-visible:outline-none"
                type="text"
                value={projectName}
                name="projectname"
                onChange={(e) => setProjectName(e.target.value)}
              />
            </div>

            <div className="relative space-y-2 w-full billing-type-project">
              <label className="font-medium text-gray-700 text-sm">
                * Customer
              </label>
              {(selectedClient || newCustomer) && (
                <p>
                  Selected Client -{" "}
                  {newCustomer?.name
                    ? newCustomer?.name
                    : selectedClient?.user?.name}
                </p>
              )}
              <div className="relative">
                <input
                  className="border-[#DBDCDE] px-2 border rounded-md w-[100%] h-[35px]"
                  type="text"
                  name="members"
                  placeholder="Search Client"
                  value={inputValue}
                  onChange={handleInputChange}
                />

                {searchedClient && (
                  <div className="top-[35px] left-0 absolute bg-gray-100 border rounded-md w-full max-h-36 overflow-y-scroll">
                    {searchedClient.length === 0 ? (
                      <p className="p-2 text-center">No client found</p>
                    ) : (
                      <ul>
                        {searchedClient?.map((client) => {
                          if (
                            client?.clientDetails?.id ===
                            newCustomer?.clientDetails?.id
                          ) {
                            return null;
                          }
                          console.log(client);
                          return (
                            <li
                              key={client?.clientDetails?.id}
                              className={`p-2 hover:bg-gray-200 cursor-pointer ${newCustomer?.clientDetails?.id ===
                                client?.clientDetails?.id
                                ? "bg-green-500 text-white hover:bg-green-500"
                                : ""
                                }`}
                              onClick={() => {
                                setNewCustomer(client);
                                setSelectClient(null);
                              }}
                            >
                              {client.name}
                            </li>
                          );
                        })}
                      </ul>
                    )}
                  </div>
                )}
                {/* <Search className="top-[6px] right-[10px] absolute" /> */}
              </div>
            </div>

            <div className="flex items-center gap-3 font-medium">
              <input
                checked
                type="checkbox"
                name="progress"
                required
                onChange={(e) => setCalculate(!calculate)}
              />
              <label for="text-[13px] font-medium progress-through ">
                Calculate progress through tasks
              </label>
            </div>

            <div className="space-y-2">
              <h1 className="font-medium text-gray-700 text-sm">Progress 0%</h1>
              <div className="border-[#D9D9D9] bg-[#27004a] border rounded-md h-[6px]"></div>
            </div>

            <div className="flex gap-10 billing-form-type w-[100%]">
              <div className="space-y-2 w-[50%] billing-type-project">
                <label className="font-medium text-gray-700 text-sm">
                  * Billing Type
                </label>
                <select
                  className="border-[#DBDCDE] bg-white pl-5 border rounded-md w-[100%] h-[40px] focus-visible:outline-none"
                  name="billingType"
                  required
                  value={billingType}
                  onChange={(e) => {
                    setBillingType(e.target.value);
                  }}
                >
                  <option value="Fixed Rate">Fixed rate</option>
                  <option value="Project Hours">Project Hours</option>
                  <option value="Task Hours Based on task hourly rate">
                    Task Hours Based on task hourly rate
                  </option>
                </select>
              </div>

              <div className="space-y-2 w-[50%] billing-type-project">
                <label className="font-medium text-gray-700 text-sm">
                  Status
                </label>
                <select
                  className="border-[#DBDCDE] bg-white pl-5 border rounded-md w-[100%] h-[40px] focus-visible:outline-none"
                  name="status"
                  required
                  defaultValue={editProject?.status || "pending"}
                  onChange={(e) => {
                    setStatus(e.target.value);
                  }}
                >
                  <option value="In Progress">In Progress</option>
                  {fetchProjectStatus?.map((s) => {
                    return <option value={s.id}>{s.project_name}</option>;
                  })}
                </select>
              </div>
            </div>

            <div className="space-y-2">
              <label className="font-medium text-gray-700 text-sm">
                Total Rate
              </label>
              <input
                name="totalRate"
                className="border-[#DBDCDE] pl-2 border rounded-md w-[100%] h-[35px] focus-visible:outline-none"
                value={rate}
                required
                onChange={(e) => {
                  setRate(e.target.value);
                }}
              />
            </div>

            <div className="space-y-2">
              <div className="gap-10 billing-form-type w-[100%]">
                <div className="space-y-2 w-[100%] billing-type-project">
                  <label className="font-medium text-gray-700 text-sm">
                    Estimated Hours
                  </label>
                  <input
                    className="border-[#DBDCDE] pl-2 border rounded-md w-[100%] h-[40px] focus-visible:outline-none"
                    name="estimatedHours"
                    value={estimateHours}
                    required
                    onChange={(e) => {
                      setEstimateHours(e.target.value);
                    }}
                  />
                </div>
                <div className="space-y-2 mt-2 billing-type-project">
                  <label className="font-medium text-gray-700 text-sm">
                    * Project Priority
                  </label>
                  <select
                    className="border-[#DBDCDE] bg-white pl-5 border rounded-md w-[100%] h-[40px] focus-visible:outline-none"
                    name="status"
                    required
                    defaultValue={editProject?.priority || "pending"}
                    onChange={(e) => {
                      setPriority(e.target.value);
                    }}
                  >
                    <option value="In Progress">In Progress</option>
                    {fetchProjectPriority?.map((s) => {
                      return <option value={s.id}>{s.Priority_name}</option>;
                    })}
                  </select>
                </div>
                <div className="mt-2">
                  <SearchStaff
                    members={members}
                    setMembers={setMembers}
                    names={names}
                  />
                </div>
              </div>

              <div className="flex gap-10 billing-form-type w-[100%]">
                <div className="space-y-2 w-[50%] billing-type-project">
                  <label className="font-medium text-gray-700 text-sm">
                    * Start Date
                  </label>
                  <input
                    className="border-[#DBDCDE] px-2 border rounded-md w-[100%] h-[35px]"
                    type="date"
                    name="startDate"
                    value={startDate}
                    required
                    onChange={(e) => {
                      setStartDate(e.target.value);
                    }}
                  />
                </div>

                <div className="space-y-2 w-[50%] billing-type-project">
                  <label className="font-medium text-gray-700 text-sm">
                    Deadline
                  </label>
                  <input
                    className="border-[#DBDCDE] px-2 border rounded-md w-[100%] h-[35px]"
                    type="date"
                    name="deadline"
                    value={deadLine}
                    required
                    onChange={(e) => {
                      setDeadLine(e.target.value);
                    }}
                  />
                </div>
              </div>

              <div className="mt-[20px]">
                <label className="font-medium text-[#000000ba] text-[13px] xl:text-[14px]">
                  Task Description
                </label>
                <br />
                <textarea
                  type="text"
                  className="border-1 mt-1 p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none"
                  required
                  value={description}
                  onChange={(e) => {
                    setDescription(e.target.value);
                  }}
                />{" "}
                <br />
              </div>
            </div>

            <div className="flex items-center gap-[10px]">
              <SellIcon />
              <Select
                isMulti
                options={tags}
                // onChange={handleChange}
                placeholder="Select or add tags..."
                className="w-full tag-selector"
                value={selectedTag}
                onChange={handleChange}
                styles={{
                  control: (provided) => ({
                    ...provided,
                    minHeight: "35px",
                    border: "1px solid #d1d5db",
                  }),
                  multiValue: (provided) => ({
                    ...provided,
                    backgroundColor: "#e5e7eb",
                    borderRadius: "4px",
                  }),
                  multiValueLabel: (provided) => ({
                    ...provided,
                    fontSize: "0.875rem",
                  }),
                  multiValueRemove: (provided) => ({
                    ...provided,
                    color: "#4b5563",
                    cursor: "pointer",
                  }),
                }}
                required
              />
            </div>

            <div className="space-x-3 border-[#B1B1B1] py-4 border-t border-b">
              <input
                type="checkbox"
                onChange={(e) => setEmailChecked(e.target.checked)}
              />
              <span className="font-medium text-gray-700 text-sm">
                Send project created email
              </span>
            </div>

            <div className="flex justify-end gap-5 pb-[20px]">
              <button
                className="border-[#27004a] bg-white border rounded-md w-20 h-10 text-[#27004a]"
                onClick={onCloseModal}
              >
                Cancel
              </button>
              <button
                type="submit"
                className={`allcrm-btn1 ${isLoading == true ? "opacity-50 cursor-not-allowed" : ""
                  }`}
                disabled={isLoading}
              >
                Save
              </button>
            </div>
          </div>
        </form>
        {/* <!-- Form ends --> */}
      </Modal>
    </div>
  );
};

export default ProjectEditModal;
